import { Outlet, useParams } from 'react-router-dom';
import { FolderOpen, Settings, Users } from 'lucide-react';
import { SimpleProjectSelector } from 'src/components/SimpleProjectSelector';
import { UserMenu } from 'src/components/UserMenu';
import { ORG_OWNER_ROLE, useGetMyInfoQuery } from 'src/hooks/useGetMyInfoQuery';
import { SidebarLayout } from 'src/layout/SidebarLayout/SidebarLayout';
import { AndiChatsSidebar } from 'src/views/project/AndiPage/components/sidebar/AndiChatsSidebar';
import { AndiNavLink } from 'src/views/project/AndiPage/components/sidebar/AndiNavLink';
import { AndiRuntimeProvider } from 'src/views/project/AndiPage/runtime/AndiRuntimeProvider';

import { CustomersSection } from '../CustomersSection/CustomersSection';
import { IntegrationsSection } from '../IntegrationsSection/IntegrationsSection';
import { SettingsSection } from '../SettingsSection';

const Sidebar = () => {
  const { data: myInfo } = useGetMyInfoQuery();
  const { projectId } = useParams();
  const isOrgOwner = myInfo?.orgRole?.role === ORG_OWNER_ROLE;

  return (
    <SidebarLayout.Sidebar>
      {/* Sidebar content goes here */}
      <SidebarLayout.SidebarHeader>
        <SimpleProjectSelector />
      </SidebarLayout.SidebarHeader>
      <SidebarLayout.SidebarMain>

        {/* Project-specific navigation items */}
        <CustomersSection />
        <IntegrationsSection />
        <SettingsSection />
        <AndiNavLink />

        {/* Home navigation items */}
        <div style={{ height: '1px', backgroundColor: 'rgb(43 43 43 / 12%)', margin: '0.75rem 0' }} />
        <SidebarLayout.SidebarMainLayout.ListNavLink
          to={`/projects/${projectId}/home/projects`}
          label="Projects"
          iconSvg={<FolderOpen size={20} />}
        />

        {/* Organization section - only show if user is org owner */}
        {isOrgOwner && (
          <>
           
            <SidebarLayout.SidebarMainLayout.ListNavLink
              to={`/projects/${projectId}/home/org-settings`}
              label="Org settings"
              iconSvg={<Settings size={20} />}
            />
            <SidebarLayout.SidebarMainLayout.ListNavLink
              to={`/projects/${projectId}/home/org-users`}
              label="Users"
              iconSvg={<Users size={20} />}
            />
          </>
        )}

        {/* Push user menu to bottom */}
        <div style={{ flex: '1' }} />
        <UserMenu />
      </SidebarLayout.SidebarMain>
    </SidebarLayout.Sidebar>
  );
};

export const SidebarProjectLayoutV2 = () => (
  <AndiRuntimeProvider>
    <SidebarLayout.LayoutContainer>
      <AndiChatsSidebar>
        <Sidebar />
      </AndiChatsSidebar>
      {/* Main page content goes here */}
      <SidebarLayout.MainPage>
        <Outlet />
      </SidebarLayout.MainPage>
    </SidebarLayout.LayoutContainer>
  </AndiRuntimeProvider>
);
